<div>
    Commission
    *If Bruges, set 85% of conf amount (except travel insurance and cancellation insurance)
</div>
<div class="top-menu">
    <p-dropdown [options]="agents" optionLabel="name"></p-dropdown>
    <p-button label="Update state" (onClick)="updatePaidState()"></p-button>
    <p-button label="Add Commission Payment" routerLink="/management/agent-commissions-create-payment"></p-button>
    <div>
        <span>Filter:</span>
        <span>Show paid only</span>
        <p-checkbox [binary]="true" (onChange)="paidAlreadyFilterChange($event.checked)"></p-checkbox>
    </div>
    <div>
        <span>Total: {{totalCommission}}</span>
    </div>
</div>
<div>
    Mode: {{filterMode}}
</div>
<table>
    <tr>
        <th>Booking id</th>
        <th>
            Start
        </th>
        <th>
            End
        </th>
        <th>
            Conf total
        </th>
        <th>
            Insurance
        </th>
        <th>
            Cancellation
        </th>
        <th>
            School Invoice
        </th>
        <th>
            Received already
        </th>
        <th>
            Remaining balance
        </th>
        <th>
            Gross margin
        </th>
        <th>
            School
        </th>
        <th>
            Info
        </th>
        <th>
            Commission
        </th>
        <th>
            Paid to agent
        </th>
    </tr>
    <tr *ngFor="let booking of filteredCommissions">
        <td>
            <a target="_blank" [href]="baseUrl + '/management/edit-booking/' + booking.bookingId">
                {{booking.bookingId}}
            </a>
        </td>
        <td class="td-with-padding">
            {{booking.startDate.format("DD/MM/YYYY")}}
        </td>
        <td class="td-with-padding">
            {{booking.endDate.format("DD/MM/YYYY")}}
        </td>
        <td>
            {{booking.confirmationAmount}}
        </td>
        <td>
            {{booking.insurance}}
        </td>
        <td>
            {{booking.cancellationInsurance}}
        </td>
        <td>
            {{booking.totalSchoolInvoice}}
        </td>
        <td>
            {{booking.receivedFromClient}}
        </td>
        <td>
            {{booking.remainingBalance}}
        </td>
        <td>
            {{booking.grossMargin}}
        </td>
        <td>
            {{booking.school.name}}
        </td>
        <td>
            <span class="error-message">
                {{booking.info}}
            </span>
        </td>
        <td>
            {{booking.commissionStr}}
        </td>
        <td>
            {{booking.isCommissionPaid}}
        </td>
    </tr>
</table>
